export enum Codeowners {
  ACCOUNTING = 'accounting',
  BILLING = 'billing',
  CHAT = 'chat',
  CUSTOMERS = 'customers',
  CUSTOMER_INTAKE = 'customer_intake',
  DATA_TRANSFER = 'data_transfer',
  ESTIMATES = 'estimates',
  FINTECH_CORE_BANKING = 'fintech_core_banking',
  FINTECH_EXPENSE_CARDS = 'fintech_expense_cards',
  FINTECH_PAYMENTS = 'fintech_payments',
  FINTECH_PAYMENTS_TOO = 'fintech_payments_too',
  FINTECH_BILL_PAY = 'fintech_bill_pay',
  FINTECH_B2B_FINANCING = 'fintech_b2b_financing',
  FINTECH_CONSUMER_FINANCING = 'fintech_consumer_financing',
  HCP_ASSIST = 'hcp_assist',
  HOMEPAGE = 'homepage',
  INNOVATION = 'innovation',
  INTERNAL_SUCCESS = 'internal_success',
  JOB_SQUAD = 'job_squad',
  ONBOARDING = 'onboarding',
  OPCON = 'opcon',
  PAYROLL = 'payroll',
  PIPELINE = 'pipeline',
  PLATFORM = 'platform',
  PRICEBOOK = 'pricebook',
  QUICKBOOKS = 'quickbooks',
  REPORTING = 'reporting',
  SCHEDULING = 'scheduling',
  VOICE = 'voice',
  INVOICES = 'invoices',
  FINTECH_RISK = 'fintech_risk',
}
